import React from "react";

// Clickable follow-up prompts the agent suggests alongside an output. Selecting one re-runs
// sendQuery with the chip text, same as typing it into the input.
export const SuggestionChips: React.FC<{
	suggestions?: string[];
	onSelect: (text: string) => void;
	disabled?: boolean;
}> = ({ suggestions, onSelect, disabled }) => {
	if (!suggestions || suggestions.length === 0) return null;

	return (
		<div className="mt-2 flex flex-wrap gap-1.5">
			{suggestions.map((suggestion, index) => (
				<button
					key={index}
					type="button"
					disabled={disabled}
					onClick={() => onSelect(suggestion)}
					className="rounded-full border border-neutral-200 bg-neutral-50 px-3 py-1 text-xs text-neutral-600 transition-colors hover:border-primary-5 hover:text-primary-5 disabled:cursor-not-allowed disabled:opacity-50"
				>
					{suggestion}
				</button>
			))}
		</div>
	);
};

export default SuggestionChips;
